<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="listing__background module__background"
        ></app-modulebackground>
        <div
            class="listing__container module__container"
            v-bind:class="{
                container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type)
            }"
        >
            <div class="listing__inner module__inner">
                <div class="listing__inner--main module__inner--main">
                    <div
                        class="listing__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text1"
                    >
                        <div class="listing__inner-col module__inner-col">
                            <div class="listing__header module__header">
                                <h2
                                    class="listing__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="listing__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="listing__text module__text font-p color-p module__cms"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="listing__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="listing__inner-col module__inner-col">
                            <div class="listing__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                    <div
                        class="listing__inner-row module__inner-row"
                        v-if="items && Array.isArray(items) && items.length > 0"
                    >
                        <div class="listing__inner-col module__inner-col">
                            <ul
                                class="listing__items"
                                v-bind:class="{
                                    listing__accordion: [1].includes(module.layout.type)
                                }"
                            >
                                <li
                                    class="listing__item border-color-highlighted"
                                    v-for="(list__value, list__key) in items"
                                    v-bind:key="list__key"
                                    v-bind:class="{
                                        'listing__accordion-item': [1].includes(module.layout.type)
                                    }"
                                >
                                    <div
                                        class="listing__accordion-container"
                                        v-if="[1].includes(module.layout.type)"
                                    >
                                        <div
                                            tabindex="0"
                                            class="listing__accordion-header listing__accordion-toggle module__link"
                                        >
                                            <div
                                                class="listing__item-title font-bold font-p color-p"
                                                v-html="
                                                    list__value.data && list__value.data.title
                                                        ? list__value.data.title
                                                        : 'Listenelement ' + (list__key + 1)
                                                "
                                            ></div>
                                            <div
                                                class="listing__accordion-arrow border-color"
                                            ></div>
                                        </div>
                                        <div class="listing__accordion-body">
                                            <div
                                                class="listing__item-text"
                                                v-if="list__value.data && list__value.data.text"
                                                v-html="list__value.data.text"
                                            ></div>
                                            <div
                                                class="listing__item-links"
                                                v-if="
                                                    list__value.data &&
                                                        ((list__value.data.link &&
                                                            list__value.data.link.active) ||
                                                            (list__value.data.link2 &&
                                                                list__value.data.link2.active) ||
                                                            (list__value.data.link3 &&
                                                                list__value.data.link3.active) ||
                                                            (list__value.data.file &&
                                                                list__value.data.file.id))
                                                "
                                            >
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link &&
                                                            list__value.data.link.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link2 &&
                                                            list__value.data.link2.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link2"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link3 &&
                                                            list__value.data.link3.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link3"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__link module__link"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.file &&
                                                            list__value.data.file.id
                                                    "
                                                >
                                                    <a
                                                        v-bind:href="
                                                            generateMediaUrl({
                                                                id: list__value.data.file.id
                                                            })
                                                        "
                                                        target="_blank"
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="listing__item-details"
                                        v-if="[2, 3].includes(module.layout.type)"
                                    >
                                        <div
                                            class="listing__item-image"
                                            v-if="[2].includes(module.layout.type)"
                                        >
                                            <app-moduleimage
                                                v-if="list__value.data && list__value.data.image"
                                                :data="list__value.data.image"
                                                :tag="'div'"
                                                :custom-class="''"
                                            >
                                            </app-moduleimage>
                                            <div
                                                v-if="!list__value.data || !list__value.data.image"
                                                class="image-container image-container--img"
                                            >
                                                <img
                                                    v-bind:src="
                                                        module.appearance.color == 1
                                                            ? generateMediaUrl({
                                                                  path:
                                                                      'media/images/listing/default/2.jpg'
                                                              })
                                                            : generateMediaUrl({
                                                                  path:
                                                                      'media/images/listing/default/1.jpg'
                                                              })
                                                    "
                                                    alt=""
                                                />
                                            </div>
                                            <span
                                                class="listing__item-label font-bold font-p color-p"
                                                v-html="
                                                    list__value.data && list__value.data.title
                                                        ? list__value.data.title
                                                        : 'Listenelement ' + (list__key + 1)
                                                "
                                            >
                                            </span>
                                        </div>
                                        <div
                                            class="listing__item-title-col"
                                            v-if="[3].includes(module.layout.type)"
                                        >
                                            <div
                                                class="listing__item-title font-bold font-p color-p"
                                                v-html="
                                                    list__value.data && list__value.data.title
                                                        ? list__value.data.title
                                                        : 'Listenelement ' + (list__key + 1)
                                                "
                                            ></div>
                                        </div>
                                        <div class="listing__item-content">
                                            <div
                                                class="listing__item-title font-bold font-p color-p"
                                                v-if="[2].includes(module.layout.type)"
                                                v-html="
                                                    list__value.data && list__value.data.title
                                                        ? list__value.data.title
                                                        : 'Listenelement ' + (list__key + 1)
                                                "
                                            ></div>
                                            <div
                                                class="listing__item-text"
                                                v-if="list__value.data && list__value.data.text"
                                                v-html="list__value.data.text"
                                            ></div>
                                            <div
                                                class="listing__item-links"
                                                v-if="
                                                    list__value.data &&
                                                        ((list__value.data.link &&
                                                            list__value.data.link.active) ||
                                                            (list__value.data.link2 &&
                                                                list__value.data.link2.active) ||
                                                            (list__value.data.link3 &&
                                                                list__value.data.link3.active) ||
                                                            (list__value.data.file &&
                                                                list__value.data.file.id))
                                                "
                                            >
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link &&
                                                            list__value.data.link.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link2 &&
                                                            list__value.data.link2.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link2"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__cta module__cta"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.link3 &&
                                                            list__value.data.link3.active
                                                    "
                                                >
                                                    <app-modulebutton
                                                        :data="list__value.data.link3"
                                                        :custom-class="
                                                            'listing__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                        "
                                                    ></app-modulebutton>
                                                </div>
                                                <div
                                                    class="listing__link module__link"
                                                    v-if="
                                                        list__value.data &&
                                                            list__value.data.file &&
                                                            list__value.data.file.id
                                                    "
                                                >
                                                    <a
                                                        v-bind:href="
                                                            generateMediaUrl({
                                                                id: list__value.data.file.id
                                                            })
                                                        "
                                                        target="_blank"
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Listing from '@/external/modules/Listing';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-modulebutton': ModuleButton,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['generateMediaUrl', 'getRandomImageInNamespace', 'editorMode']),
        items() {
            return toArray(this.module.data.items)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        module: Object
    },
    mounted() {
        if (this.editorMode) {
            let i = new Listing();
            i.init(this.$refs.root);
        }
    },
    updated() {}
};
</script>
